import styles from "./Skeleton.module.scss";

export default function SkeletonCalendar() {
  return (
    <div className={styles.SkeletonCalendar}>
      <div className={styles.loader}>
        <div className={styles.spinner}></div>
      </div>
      <div className={styles.header}>
        <div className={styles.month}></div>
        <div className={styles.navigation}>
          <div className={styles.arrow}></div>
          <div className={styles.arrow}></div>
        </div>
      </div>
      <div className={styles.weekdays}>
        {Array.from({ length: 7 }).map((_, i) => (
          <div key={i} className={styles.weekday}></div>
        ))}
      </div>
      <div className={styles.dates}>
        {Array.from({ length: 35 }).map((_, i) => (
          <div key={i} className={`${styles.date} ${styles.shimmer}`}></div>
        ))}
      </div>
    </div>
  );
}
